import React, { useState, useEffect, useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import "./App.css";
import Video from "./Component/Video/BaliYatra.mp4";

const App = () => {
  const book = useRef();
  const images = [
    "./images/Baliyatra/1.jpg",
    "./images/Baliyatra/2.jpg",
    "./images/Baliyatra/3.jpg",
    "./images/Baliyatra/4.jpg",
    "./images/Baliyatra/5.jpg",
    "./images/Baliyatra/6.jpg",
    "./images/Baliyatra/7.jpg",
    "./images/Baliyatra/8.jpg",
    "./images/Baliyatra/9.jpg",
    "./images/Baliyatra/10.jpg",
    "./images/Baliyatra/11.jpg",
    "./images/Baliyatra/12.jpg",
    "./images/Baliyatra/13.jpg",
    "./images/Baliyatra/14.jpg",
    "./images/Baliyatra/15.jpg",
    "./images/Baliyatra/16.jpg",
    "./images/Baliyatra/17.jpg",
    "./images/Baliyatra/18.jpg",
    "./images/Baliyatra/19.jpg",
    "./images/Baliyatra/20.jpg",
    "./images/Baliyatra/21.jpg",
    "./images/Baliyatra/22.jpg",
    "./images/Baliyatra/23.jpg",
    "./images/Baliyatra/24.jpg",
    "./images/Baliyatra/25.jpg",
    "./images/Baliyatra/26.jpg",
    "./images/Baliyatra/27.jpg",
    "./images/Baliyatra/28.jpg",
    "./images/Baliyatra/29.jpg",
    "./images/Baliyatra/30.jpg",
    "./images/Baliyatra/31.jpg",
    "./images/Baliyatra/32.jpg",
    "./images/Baliyatra/33.jpg",
    "./images/Baliyatra/34.jpg",
    "./images/Baliyatra/35.jpg",
    "./images/Baliyatra/36.jpg",
    "./images/Baliyatra/37.jpg",
    "./images/Baliyatra/38.jpg",
    "./images/Baliyatra/39.jpg",
    "./images/Baliyatra/40.jpg",
    "./images/Baliyatra/41.jpg",
    "./images/Baliyatra/42.jpg",
    "./images/Baliyatra/43.jpg",
    "./images/Baliyatra/44.jpg",
    "./images/Baliyatra/45.jpg",
    "./images/Baliyatra/46.jpg",
    "./images/Baliyatra/47.jpg",
    "./images/Baliyatra/48.jpg",
    "./images/Baliyatra/49.jpg",
    "./images/Baliyatra/50.jpg",
    "./images/Baliyatra/51.jpg",
    "./images/Baliyatra/52.jpg",
    "./images/Baliyatra/53.jpg",
    "./images/Baliyatra/54.jpg",
    "./images/Baliyatra/55.jpg",
    "./images/Baliyatra/56.jpg",
    "./images/Baliyatra/57.jpg",
    "./images/Baliyatra/58.jpg",
    "./images/Baliyatra/Content/1.jpg",
    "./images/Baliyatra/Content/2.jpg",
    "./images/Baliyatra/Content/3.jpg",
    "./images/Baliyatra/Content/4.jpg",
    "./images/Baliyatra/Content/5.jpg",
    "./images/Baliyatra/Content/6.jpg",
    "./images/Baliyatra/Content/7.jpg",
    "./images/Baliyatra/Content/8.jpg",
    "./images/Baliyatra/Content/9.jpg",
    "./images/Baliyatra/Content/10.jpg",
    "./images/Baliyatra/Content/11.jpg",
    "./images/Baliyatra/Content/12.jpg",
    "./images/Baliyatra/Content/13.jpg",
    "./images/Baliyatra/Content/14.jpg",
    "./images/Baliyatra/Content/15.jpg",
    "./images/Baliyatra/Content/16.jpg",
    "./images/Baliyatra/Content/17.jpg",
    "./images/Baliyatra/Content/18.jpg",
    "./images/Baliyatra/Content/19.jpg",
    "./images/Baliyatra/Content/20.jpg",
    "./images/Baliyatra/Content/21.jpg",
    "./images/Baliyatra/Content/22.jpg",
    "./images/Baliyatra/Content/23.jpg",
    "./images/Baliyatra/Content/24.jpg",
    "./images/Baliyatra/Content/25.jpg",
    "./images/Baliyatra/Content/26.jpg",
    "./images/Baliyatra/Content/27.jpg",
    "./images/Baliyatra/Content/28.jpg",
    "./images/Baliyatra/Content/29.jpg",
    "./images/Baliyatra/Content/30.jpg",
    "./images/Baliyatra/Content/31.jpg",
    "./images/Baliyatra/Content/32.jpg",
    "./images/Baliyatra/Content/33.jpg",
    "./images/Baliyatra/Content/34.jpg",
    "./images/Baliyatra/Content/35.jpg",
    "./images/Baliyatra/Content/36.jpg",
    "./images/Baliyatra/Content/37.jpg",
    "./images/Baliyatra/Content/38.jpg",
    "./images/Baliyatra/Content/39.jpg",
    "./images/Baliyatra/Content/40.jpg",
    "./images/Baliyatra/Content/41.jpg",
    "./images/Baliyatra/Content/42.jpg",
    "./images/Baliyatra/Content/43.jpg",
    "./images/Baliyatra/Content/44.jpg",
    "./images/Baliyatra/Content/45.jpg",
    "./images/Baliyatra/Content/46.jpg",
    "./images/Baliyatra/Content/47.jpg",
    "./images/Baliyatra/Content/48.jpg",
    "./images/Baliyatra/Content/49.jpg",
    "./images/Baliyatra/Content/50.jpg",
    "./images/Baliyatra/Content/51.jpg",
    "./images/Baliyatra/Content/52.jpg",
    "./images/Baliyatra/Content/53.jpg",
    "./images/Baliyatra/Content/54.jpg",
    "./images/Baliyatra/Content/55.jpg",
    "./images/Baliyatra/Content/56.jpg",
    "./images/Baliyatra/Content/57.jpg",
    "./images/Baliyatra/Content/58.jpg",
    "./images/Baliyatra/Content/59.jpg",
    "./images/Baliyatra/Content/60.jpg",
    "./images/Baliyatra/Content/61.jpg",
    "./images/Baliyatra/Content/62.jpg",
    "./images/Baliyatra/Content/63.jpg",
    "./images/Baliyatra/Content/64.jpg",
    "./images/Baliyatra/Content/65.jpg",
    "./images/Baliyatra/Content/66.jpg",
    "./images/Baliyatra/Content/67.jpg",
    "./images/Baliyatra/Content/68.jpg",
    "./images/Baliyatra/Content/69.jpg",
    "./images/Baliyatra/Content/70.jpg",
    "./images/Baliyatra/Content/71.jpg",
    "./images/Baliyatra/Content/72.jpg",
    "./images/Baliyatra/Content/73.jpg",
    "./images/Baliyatra/Content/74.jpg",
    "./images/Baliyatra/Content/75.jpg",
    "./images/Baliyatra/Content/76.jpg",
    "./images/Baliyatra/Content/77.jpg",
    "./images/Baliyatra/Content/78.jpg",
    "./images/Baliyatra/Content/79.jpg",
    "./images/Baliyatra/Content/80.jpg",
    "./images/Baliyatra/Content/81.jpg",
    "./images/Baliyatra/Content/82.jpg",
    "./images/Baliyatra/Content/83.jpg",
    "./images/Baliyatra/Content/84.jpg",
    "./images/Baliyatra/Content/85.jpg",
    "./images/Baliyatra/Content/86.jpg",
    "./images/Baliyatra/Content/87.jpg",
    "./images/Baliyatra/Content/88.jpg",
    "./images/Baliyatra/Content/89.jpg",
    "./images/Baliyatra/Content/90.jpg",
    "./images/Baliyatra/Content/91.jpg",
    "./images/Baliyatra/Content/92.jpg",
    "./images/Baliyatra/Content/93.jpg",
    "./images/Baliyatra/Content/94.jpg",
    "./images/Baliyatra/Content/95.jpg",
    "./images/Baliyatra/Content/96.jpg",
    "./images/Baliyatra/Content/97.jpg",
    "./images/Baliyatra/Content/98.jpg",
    "./images/Baliyatra/Content/99.jpg",
    "./images/Baliyatra/Content/100.jpg",
    "./images/Baliyatra/Content/101.jpg",
    "./images/Baliyatra/Content/102.jpg",
    "./images/Baliyatra/Content/103.jpg",
    "./images/Baliyatra/Content/104.jpg",
    "./images/Baliyatra/Content/105.jpg",
    "./images/Baliyatra/Content/106.jpg",
    "./images/Baliyatra/Content/107.jpg",
    "./images/Baliyatra/Content/108.jpg",
    "./images/Baliyatra/Content/109.jpg",
    "./images/Baliyatra/Content/110.jpg",
    "./images/Baliyatra/Content/111.jpg",
    "./images/Baliyatra/Content/112.jpg",
    "./images/Baliyatra/Content/113.jpg",
    "./images/Baliyatra/Content/114.jpg",
    "./images/Baliyatra/Content/115.jpg",
    "./images/Baliyatra/Content/116.jpg",
    "./images/Baliyatra/Content/117.jpg",
    "./images/Baliyatra/Content/118.jpg",
    "./images/Baliyatra/Content/119.jpg",
    "./images/Baliyatra/Content/120.jpg",
    "./images/Baliyatra/Content/121.jpg",
    "./images/Baliyatra/Content/122.jpg",
    "./images/Baliyatra/Content/123.jpg",
    "./images/Baliyatra/Content/124.jpg",
    "./images/Baliyatra/Content/125.jpg",
    "./images/Baliyatra/Content/126.jpg",
    "./images/Baliyatra/Content/127.jpg",
    "./images/Baliyatra/Content/128.jpg",
    "./images/Baliyatra/Content/129.jpg",
    "./images/Baliyatra/Content/130.jpg",
    "./images/Baliyatra/Content/131.jpg",
    "./images/Baliyatra/Content/132.jpg",
    "./images/Baliyatra/Content/133.jpg",
    "./images/Baliyatra/Content/134.jpg",
    "./images/Baliyatra/Content/135.jpg",
    "./images/Baliyatra/Content/136.jpg",
    "./images/Baliyatra/Content/137.jpg",
    "./images/Baliyatra/Content/138.jpg",
    "./images/Baliyatra/Content/139.jpg",
    "./images/Baliyatra/Content/140.jpg",
    "./images/Baliyatra/Content/141.jpg",
    "./images/Baliyatra/Content/142.jpg",
    "./images/Baliyatra/Content/143.jpg",
    "./images/Baliyatra/Content/144.jpg",
  ];
  const [isBookStart, setIsBookStart] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleFlip = () => {
    setIsBookStart(true);
  };

  const handleDownload = () => {
    window.open(
      "https://brainsietechnologies-my.sharepoint.com/:b:/g/personal/info_brainsietech_com/EcBz29FK2BBFm43ak_k8w38B2gTdZEHJ0CsmwpkDfLJg0A?e=Q2HP04",
      "_blank"
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="App">
      {!isBookStart ? (
        <div className="video-container">
          <video className="fullscreen-video" autoPlay muted loop playsInline>
            <source src={Video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="overlay">
            <button onClick={handleFlip}>Get Started</button>
          </div>
        </div>
      ) : isMobile ? (
        <div className="mobile-view">
          {images.map((image, index) => (
            <div className="mobile-page" key={index}>
              <img
                src={image}
                alt={`Page ${index + 1}`}
                className="mobile-image"
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="book-view">
          <HTMLFlipBook
            width={300}
            height={400}
            size="stretch"
            minWidth={200}
            maxWidth={600}
            minHeight={300}
            maxHeight={420}
            drawShadow={true}
            flippingTime={1000}
            useMouseEvents={true}
            className="flipbook"
            ref={book}
          >
            {images.map((image, index) => (
              <div className="page" key={index}>
                <img
                  src={image}
                  alt={`Page ${index + 1}`}
                  className="page-image"
                />
              </div>
            ))}
          </HTMLFlipBook>
          <button onClick={() => book.current.pageFlip().flipNext()} className="next-button">
            Next 
          </button>
          <button onClick={() => book.current.pageFlip().flipPrev()} className="prev-button">
            Previous 
          </button>
        </div>
      )}
      <button className="pdf-download-button" onClick={handleDownload}>
        Download PDF
      </button>
    </div>
  );
};

export default App;
